import { BriefingOrganizeByEnum } from '../enums/briefing-organize-by.enum';

export const briefingSavedSourceOrganizeOptions: {label: string; value: BriefingOrganizeByEnum}[] = [
    {
        label: 'Briefings.input.organizeSectionsBy.manual',
        value: BriefingOrganizeByEnum.MANUAL
    },
    {
        label: 'Briefings.input.organizeSectionsBy.sentiment',
        value: BriefingOrganizeByEnum.SENTIMENT
    },
    {
        label: 'Briefings.input.organizeSectionsBy.mediaType',
        value: BriefingOrganizeByEnum.MEDIA_TYPE
    },
    {
        label: 'Briefings.input.organizeSectionsBy.tags',
        value: BriefingOrganizeByEnum.TAGS
    }
];

export const briefingUnsavedSourceOrganizeOptions: {label: string; value: BriefingOrganizeByEnum}[] = [
    {
        label: 'Briefings.input.organizeSectionsBy.all',
        value: BriefingOrganizeByEnum.ALL
    },
    {
        label: 'Briefings.input.organizeSectionsBy.sentiment',
        value: BriefingOrganizeByEnum.SENTIMENT
    },
    {
        label: 'Briefings.input.organizeSectionsBy.mediaType',
        value: BriefingOrganizeByEnum.MEDIA_TYPE
    }
];
